// 刪組織家戶的文案（SPEC #org-tree-ui-home-delete；長期保管那段照 #vms-web-export-archive「刪家戶」，文案同 home-base DeleteHomeDialog）。
import { isKinioError } from '@kinio/web-sdk';
import type { ExportArchives } from '../../lib/orgTreeApi';
import { dateStamp } from '../../lib/timefmt';
import { otErr } from './otErr';

type T = (k: string, o?: Record<string, unknown>) => string;

/** 長期保管那一段：還在讀（undefined）→ 不畫；讀不到 / null → 通用說明；0 包 → 不畫；有 → 包數 + 最晚到期日。 */
export function archivesNoticeText(t: T, leaf: string, a: ExportArchives | null | 'unknown' | undefined, tz?: string): string | null {
  if (a === undefined) return null;
  if (a === null || a === 'unknown') return t('ot.home_delete_archives_unknown', { leaf });
  if (!(a.count > 0)) return null;
  const date = a.latest_expire_at ? dateStamp(a.latest_expire_at, tz) : '';
  return date ? t('ot.home_delete_archives_n', { leaf, count: a.count, date }) : t('ot.home_delete_archives_n_nodate', { leaf, count: a.count });
}

/** 設備那一句：0 台 / N 台。 */
export function deviceWarnText(t: T, leaf: string, count: number): string {
  return count > 0 ? t('ot.home_delete_warn_n', { leaf, count }) : t('ot.home_delete_warn_empty', { leaf });
}

/** 刪除失敗：解綁失敗（家戶沒刪、可重試）/ 已不存在 / 沒權限；其他照組織樹錯誤文案。 */
export function deleteHomeErrText(t: T, leaf: string, e: unknown): string {
  if (isKinioError(e)) {
    if (e.code === 'UNBIND_FAILED') return t('ot.err_home_unbind_failed', { leaf });
    if (e.code === 'HOME_NOT_FOUND') return t('ot.err_home_not_found', { leaf });
    if (e.code === 'FORBIDDEN') return t('ot.err_home_delete_forbidden', { leaf });
  }
  return otErr(t, e);
}
